import React from 'react';
import { makeStyles } from "@mui/styles";
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import {People, HomeWork, AddLocation,PhotoLibrary,ThumbUp, Lock, ExpandLess, ExpandMore, Search, CameraAlt, Elevator, Person, GroupWork, SettingsRemote, ViewQuilt, More, Logout, Settings, Redeem, Star, Inventory, AutoAwesome, House, AccessibleRounded, Business, Face, HeadsetMic, Email, Approval} from '@mui/icons-material';
import {Image,TextFields,Tv,WbSunny,Visibility,ListAlt,Poll,Info,AccountCircle,Help} from '@mui/icons-material';
import UserMgmt from './usermgmt/UserMgmt';
import {AppBar,Toolbar,Button, Card} from '@mui/material';
import DeviceMgmt from './devicemgmt/DeviceMgmt';
import GroupMgmt from './devicemgmt/GroupMgmt';
import RemoteDeviceMgmt from './devicemgmt/RemoteDeviceMgmt';
import ElevatorMgmt from './elevator/ElevatorMgmt';
import ElevatorStatistics from './elevator/ElevatorStatistics';
import ContentLibrary from './contentmgmt/ContentLibrary';
import Playlist from './contentmgmt/Playlist'
import { Divider } from '@mui/material';
import EditText from './contentmgmt/EditText';
import LayoutDesigner from './devicemgmt/LayoutDesigner';
import WeatherInfo from './contentmgmt/WeatherInfo';
import SurveyMgmt from './contentmgmt/SurveyMgmt';
import VoucherMgmt from './contentmgmt/VoucherMgmt';
import Support from './about/Support';
import AuditLog from './about/AuditLog';
import AccountUpgrade from './about/AccountUpgrade';
import EditUserAccount from './about/EditUserAccount';
import {Equalizer,Videocam,Security,AvTimer,RssFeed,Event,Engineering} from '@mui/icons-material';
import SecurityMgmtIPCamera from './security/SecurityMgmtIPCamera';
import SecurityMgmt from './security/SecurityMgmt';
import Countdown from './contentmgmt/Countdown';
import FloorDirectory from './contentmgmt/FloorDirectory';
import RSSCreator from './contentmgmt/RSSCreator';
import Newsticker from './contentmgmt/Newsticker';
import Calendar from './contentmgmt/Calendar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { FormattedMessage} from 'react-intl';
import ReactCountryFlag from "react-country-flag";
import ServiceTechnician from './elevator/ServiceTechnician';
import JobDefinition from './elevator/JobDefinition';
import Jobs from './elevator/Jobs';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import {Build,Work,WhatsApp,Storage} from '@mui/icons-material';
import Whatsapp from './contentmgmt/Whatsapp';
import OnPremisesServers from './devicemgmt/OnPremisesServers';
import * as ETVConstants from './ETVConstants';
import VerifiedUser from '@mui/icons-material/VerifiedUser';
import AdvertisingConfig from './advertising/AdvertisingConfig';
import AdvertisingApprovals from './advertising/AdvertisingApprovals';
import ExistingApprovals from './advertising/ExistingApprovals';
import AccessMgmt from './building/AccessMgmt';
import CardMgmt from './security/CardMgmt';
import DeviceFloorMgmt from './building/DeviceFloorMgmt';
import FaceTerminalMgmt from './security/FaceTerminalMgmt';
import IntercomMgmt from './elevator/IntercomMgmt';
import EmailAdapter from './contentmgmt/MessagingAdapter';
import ApprovalLibrary from './contentmgmt/ApprovalLibrary';
import { CalendarIcon } from '@mui/x-date-pickers';
import ContentPlanner from './contentmgmt/ContentPlanner';

const list_width = '270px';
const header_height = '60px';
const marginL = '10px';

const useStyles = makeStyles((theme) => ({
  root: {
    background:'white',
    display:'flex',
    marginLeft:'0px',
    margin: '5px',
    color:'#1C1C1C',
    width: "100%",
    boxSizing: "border-box",
  },

  appBar: {
    zIndex:1,
    position:'fixed',
    background:'#FFFFFF',
    height:header_height,
    marginLeft: 'auto',
  },

  list: {
    zIndex:0,
    background:'white',
    position:'flex',
    marginTop: header_height,
    width: list_width,
    maxWidth:list_width,
    minWidth:list_width,
    backgroundColor:'white',
    color:'#1C1C1C',
    flex: "0 0 auto", 
  },

  nested: {
    paddingLeft: '50px',
    color:'black',
  },

  content: {
    zIndex:0,
    background: 'white',
    marginLeft: marginL,
    marginTop: header_height,
    flex: "1 1 auto", 
    width: "100%",
    minWidth: 0,
    boxSizing: "border-box",
    display: "flex",              
    justifyContent: "flex-start",
    alignItems: "stretch",
  }

}));


export default function Portal(props) {

  const classes = useStyles();

  // content
  const [open1, setOpen1] = React.useState(false);
  const handleClick1 = () => {
    setOpen1(!open1);
    setOpen2(false);
    setOpen3(false);
    setOpen4(false);
    setOpen5(false);
    setOpen6(false);
    setOpen7(false);
    setOpen8(false);
    setOpen9(false);
    setOpen10(false);
  };

  // device
  const [open2, setOpen2] = React.useState(false);
  const handleClick2 = () => {
    setOpen1(false);
    setOpen2(!open2);
    setOpen3(false);
    setOpen4(false);
    setOpen5(false);
    setOpen6(false);
    setOpen7(false);
    setOpen8(false);
    setOpen9(false);
    setOpen10(false);
  };

  const [open3, setOpen3] = React.useState(false);
  const handleClick3 = () => {
    setOpen1(false);
    setOpen2(false);
    setOpen3(!open3);
    setOpen4(false);
    setOpen5(false);
    setOpen6(false);
    setOpen7(false);
    setOpen8(false);
    setOpen9(false);
    setOpen10(false);
  };

  const [open4, setOpen4] = React.useState(false);
  const handleClick4 = () => {
    setOpen1(false);
    setOpen2(false);
    setOpen3(false);
    setOpen4(!open4);
    setOpen5(false);
    setOpen6(false);
    setOpen7(false);
    setOpen8(false);
    setOpen9(false);
    setOpen10(false);
  };

  const [open5, setOpen5] = React.useState(false);
  const handleClick5 = () => {
    setOpen1(false);
    setOpen2(false);
    setOpen3(false);
    setOpen4(false);
    setOpen5(!open5);
    setOpen6(false);
    setOpen7(false);
    setOpen8(false);
    setOpen9(false);
    setOpen10(false);
  };

  const [open6, setOpen6] = React.useState(false);
  const handleClick6 = () => {
    setOpen1(false);
    setOpen2(false);
    setOpen3(false);
    setOpen4(false);
    setOpen5(false);
    setOpen6(!open6);
    setOpen7(false);
    setOpen8(false);
    setOpen9(false);
    setOpen10(false);
  };

  const [open7, setOpen7] = React.useState(false);
  const handleClick7 = () => {
    setOpen1(false);
    setOpen2(false);
    setOpen3(false);
    setOpen4(false);
    setOpen5(false);
    setOpen6(false);
    setOpen7(!open7);
    setOpen8(false);
    setOpen9(false);
    setOpen10(false);
  };

  const [open8, setOpen8] = React.useState(false);
  const handleClick8 = () => {
    setOpen1(false);
    setOpen2(false);
    setOpen3(false);
    setOpen4(false);
    setOpen5(false);
    setOpen6(false);
    setOpen7(false);
    setOpen8(!open8);
    setOpen9(false);
    setOpen10(false);
  };

  const [open9, setOpen9] = React.useState(false);
  const handleClick9 = () => {
    setOpen1(false);
    setOpen2(false);
    setOpen3(false);
    setOpen4(false);
    setOpen5(false);
    setOpen6(false);
    setOpen7(false);
    setOpen8(false);
    setOpen9(!open9);
    setOpen10(false);
  };

  const [open10, setOpen10] = React.useState(false);
  const handleClick10 = () => {
    setOpen1(false);
    setOpen2(false);
    setOpen3(false);
    setOpen4(false);
    setOpen5(false);
    setOpen6(false);
    setOpen7(false);
    setOpen8(false);
    setOpen9(false);
    setOpen10(!open10);
  };


  const [curPage, setPage] = React.useState(-1);
  const showPage = (whichPage) => {
    //console.log("showPage="+whichPage);
    setPage(whichPage);
  }

  const setLang = (lang) => {
    var accessToken = localStorage.getItem("etv.access_token");
    var reqUserID = localStorage.getItem("etv.user_id");
    var url = ETVConstants.getServerBase()+'/useradmin?action=set_language&user_id='+props.user_id+"&lang="+lang;
    fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
    .then((response) => response.json())
    .then((responseJson) => {
      if(responseJson["result"]) {
        props.langCallback(lang);
      }
    })
    .catch((error) => {
    });
  }

  function trans( msgID) {
    return <FormattedMessage id={msgID} defaultMessage={"["+msgID+"]"} />
  }

///////////////////////////////////////////////////////////////////////////////
// roles
// [library,marketplace,playlist,create_text,weather_info,surveys,coupons,reservations,device_configuration,remote_management,layout_designer,user_management,elevator_config,elevator_statistics]
///////////////////////////////////////////////////////////////////////////////

  function hasCategory( cat) {
    //console.log("hasCategory ("+cat+")? all="+props.roles);
    for(var i=0; i<props.roles.length; i++) {
      //console.log("hasCategory="+cat+" ["+props.roles[i]+"]");
      if(props.roles[i].indexOf("."+cat+".")>0) {
        //console.log("...yes");
        return true;
      }
    }
    //console.log("...no");
    return false;
  }

  function hasRole(role) {
    for(var i=0; i<props.roles.length; i++) {
      var r = props.roles[i].substring(props.roles[i].lastIndexOf(".")+1,props.roles[i].length);
      if(r===role) return true;
    }
    return false;
    //return props.roles.includes(role);
  }

  function getUserStatus() {
    return props.status;
  }

  // library,marketplace,playlist,create_text,weather_info,surveys,coupons,reservations
  function hasContentCategory() {
    return hasCategory("content");
  }

  function hasDeviceCategory() {
    //console.log("======>"+props.status);
    if(props.status==='marketplace_provider') return false;
    //return true; //everyone shall have the device grouping
    return hasCategory("device");
  }

  function hasUserCategory() {
    return hasCategory("usermgmt");
  }

  function hasAdvertisingCategory() {
    //return true;
    return hasCategory("advertising");
  }

  function hasElevatorCategory() {
    return hasCategory("elevator");
  }

  function hasSecurityCategory() {
    return hasCategory("security");
  }

  function hasBuildingDefinitionCategory() {
    return hasCategory("building");
  }

  function isJobAdmin() {
    // maybe used in future
    return false;
  }

  function canRelease() {
    return false;
  }

  function canReview() {
    return false;
  }

////////////////////////////////////////////////////////
// menu AppBar
////////////////////////////////////////////////////////

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  function isOnPremise( domain) {
    var temp = domain.trim().toLowerCase();
    if(temp === 'localhost') return true;
    if(temp.startsWith('10.')) return true;
    if(temp.startsWith('172.')) return true;
    if(temp.startsWith('127.')) return true;
    if(temp.startsWith('192.168.')) return true;
    return false;
  };

  function isSuperAdmin() {
    return (props.status === "superadmin");
  }

  function hasWhatsApp() {
    return true;
    //return isSuperAdmin();
  }

  return (
    <div className={classes.root}>
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
            <Box display='flex' flexGrow={1}><img style={{height:50}} src={ETVConstants.getLogo()} alt=''/></Box>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                <Select
                    labelId="language"
                    id="language"
                    autoWidth
                    value={props.lang}
                    onChange={(e)=>{setLang(e.target.value)}}>
                     <MenuItem value='en'><ReactCountryFlag countryCode="us" svg />&nbsp;English</MenuItem>
                     <MenuItem value='de'><ReactCountryFlag countryCode="de" svg />&nbsp;Deutsch</MenuItem>
                     <MenuItem value='fr'><ReactCountryFlag countryCode="fr" svg />&nbsp;French</MenuItem>
                     <MenuItem value='jp'><ReactCountryFlag countryCode="jp" svg />&nbsp;Japanese</MenuItem>
                     <MenuItem value='vn'><ReactCountryFlag countryCode="vn" svg />&nbsp;Vietnamese</MenuItem>
                     <MenuItem value='th'><ReactCountryFlag countryCode="th" svg />&nbsp;Thai</MenuItem>
                </Select>
            </FormControl>
            <span style={{marginLeft:30}} />
            <AccountCircle color='primary' fontSize='large'/>
            <span style={{marginLeft:10}} />
            <Typography variant='body1' style={{color:'black'}}>{props.username}</Typography>
            <span style={{marginLeft:30}} />
            <Button variant='contained' startIcon={<Logout/>} color='primary' onClick={()=>{props.loggedInCallback(false)}}>{trans('logout')}</Button>
        </Toolbar>
      </AppBar>

      <List
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader component="div" id="nested-list-subheader">
          </ListSubheader>
        }
        className={classes.list} >

        {!hasContentCategory()?<span/>:<div>

            <ListItem button onClick={handleClick1} style={open1?{background:'#e9eff2'}:{}}>
              <ListItemIcon>
                <Image />
              </ListItemIcon>
              <ListItemText primary={trans("content")} sx={{cursor: 'pointer'}} />
              {open1 ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open1} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {!hasRole("playlist")?<span/>:
                  <ListItem button onClick={()=>showPage(10)} className={classes.nested}>
                    <ListItemIcon><FormatListNumberedIcon/></ListItemIcon>
                    <ListItemText primary={trans("playlist")} sx={{cursor: 'pointer'}}/>
                  </ListItem>
                }
                {!hasRole("playlist")?<span/>:
                  <ListItem button onClick={()=>showPage(195)} className={classes.nested}>
                    <ListItemIcon><CalendarIcon/></ListItemIcon>
                    <ListItemText primary={trans("content_planner")} sx={{cursor: 'pointer'}}/>
                  </ListItem>
                }
                {!hasRole("library")?<span/>:
                  <ListItem button onClick={()=>showPage(11)} className={classes.nested}>
                    <ListItemIcon><PhotoLibrary/></ListItemIcon>
                    <ListItemText primary={trans("library")} sx={{cursor: 'pointer'}}/>
                  </ListItem>
                }
                {!hasRole("library") || ETVConstants.ON_PREMISE_VERSION ?<span/>:
                  <ListItem button onClick={()=>showPage(194)} className={classes.nested}>
                    <ListItemIcon><Approval/></ListItemIcon>
                    <ListItemText primary={trans("approvals")} sx={{cursor: 'pointer'}}/>
                  </ListItem>
                }                
                {!hasRole("create_text")?<span/>:
                  <ListItem button onClick={()=>showPage(12)} className={classes.nested}>
                    <ListItemIcon><TextFields/></ListItemIcon>
                    <ListItemText primary={trans("create_text")} sx={{cursor: 'pointer'}}/>
                  </ListItem>
                }
                {!hasRole("create_text")?<span/>:
                  <ListItem button onClick={()=>showPage(13)} className={classes.nested}>
                    <ListItemIcon><More/></ListItemIcon>
                    <ListItemText primary={trans("ticker_text")} sx={{cursor: 'pointer'}}/>
                  </ListItem>
                }
                {!hasRole("weather_info") || ETVConstants.ON_PREMISE_VERSION?<span/>:
                  <ListItem button onClick={()=>showPage(14)} className={classes.nested}>
                    <ListItemIcon><WbSunny/></ListItemIcon>
                    <ListItemText primary={trans("weather_info")} sx={{cursor: 'pointer'}} />
                  </ListItem>
                }
                {!hasRole("surveys") || ETVConstants.ON_PREMISE_VERSION?<span/>:
                  <ListItem button onClick={()=>showPage(15)} className={classes.nested}>
                    <ListItemIcon><Poll/></ListItemIcon>
                    <ListItemText primary={trans("surveys")} sx={{cursor: 'pointer'}}/>
                  </ListItem>
                }
                {!hasRole("coupons") || ETVConstants.ON_PREMISE_VERSION?<span/>:
                  <ListItem button onClick={()=>showPage(16)} className={classes.nested}>
                    <ListItemIcon><CardGiftcardIcon/></ListItemIcon>
                    <ListItemText primary={trans("coupons")} sx={{cursor: 'pointer'}}/>
                  </ListItem>
                }
                {!hasRole("create_text") || ETVConstants.ON_PREMISE_VERSION?<span/>:
                  <ListItem button onClick={()=>showPage(17)} className={classes.nested}>
                    <ListItemIcon><AvTimer/></ListItemIcon>
                    <ListItemText primary={trans("countdown_ticker")} sx={{cursor: 'pointer'}}/>
                  </ListItem>
                }
                {!hasRole("playlist") || !hasDeviceCategory() ?<span/>:
                  <ListItem button onClick={()=>showPage(18)} className={classes.nested}>
                    <ListItemIcon><ListAlt/></ListItemIcon>
                    <ListItemText primary={trans("floor_directory")} sx={{cursor: 'pointer'}}/>
                  </ListItem>
                }
                {!hasRole("create_text") || ETVConstants.ON_PREMISE_VERSION?<span/>:
                  <ListItem button onClick={()=>showPage(19)} className={classes.nested}>
                    <ListItemIcon><RssFeed/></ListItemIcon>
                    <ListItemText primary={trans("rss_feeds")} sx={{cursor: 'pointer'}}/>
                  </ListItem>
                }
                {!hasRole("create_text") || ETVConstants.ON_PREMISE_VERSION?<span/>:
                  <ListItem button onClick={()=>showPage(191)} className={classes.nested}>
                    <ListItemIcon><Event/></ListItemIcon>
                    <ListItemText primary={trans("calendar")} sx={{cursor: 'pointer'}}/>
                  </ListItem>
                }
                {/*
                {!hasRole("whatsapp") || ETVConstants.ON_PREMISE_VERSION?<span/>:
                  <ListItem button onClick={()=>showPage(192)} className={classes.nested}>
                    <ListItemIcon><WhatsApp/></ListItemIcon>
                    <ListItemText primary={trans("whatsapp")} sx={{cursor: 'pointer'}}/>
                  </ListItem>
                }
                */}
                {!hasRole("library") || ETVConstants.ON_PREMISE_VERSION ?<span/>:
                  <ListItem button onClick={()=>showPage(193)} className={classes.nested}>
                    <ListItemIcon><Email/></ListItemIcon>
                    <ListItemText primary={trans("messaging")} sx={{cursor: 'pointer'}}/>
                  </ListItem>
                }

              </List>
            </Collapse>
            <Divider/>
        </div>}

        {!hasDeviceCategory()?<span/>:<div>
            <ListItem button onClick={handleClick2} style={open2?{background:'#e9eff2'}:{}}>
              <ListItemIcon>
                <Tv/>
              </ListItemIcon>
              <ListItemText primary={trans("screens")} sx={{cursor: 'pointer'}} />
              {open2 ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open2} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {!hasRole("device_configuration")?<span/>:
                  <ListItem button onClick={()=>showPage(20)} className={classes.nested}>
                    <ListItemIcon><Tv/></ListItemIcon>
                    <ListItemText primary={trans("screens")} sx={{cursor: 'pointer'}}/>
                  </ListItem>
                }
                {!hasRole("device_configuration")?<span/>:
                  <ListItem button onClick={()=>showPage(23)} className={classes.nested}>
                    <ListItemIcon><GroupWork/></ListItemIcon>
                    <ListItemText primary={trans("grouping")} sx={{cursor: 'pointer'}} />
                  </ListItem>
                }
                {!hasRole("remote_management")?<span/>:
                  <ListItem button onClick={()=>showPage(21)} className={classes.nested}>
                    <ListItemIcon><SettingsRemote/></ListItemIcon>
                    <ListItemText primary={trans("remote_management")} sx={{cursor: 'pointer'}}/>
                  </ListItem>
                }
                {!hasRole("layout_designer")?<span/>:
                  <ListItem button onClick={()=>showPage(22)} className={classes.nested}>
                    <ListItemIcon><ViewQuilt/></ListItemIcon>
                    <ListItemText primary={trans("layout_designer")} sx={{cursor: 'pointer'}} />
                  </ListItem>
                }
                {!isSuperAdmin() || ETVConstants.ON_PREMISE_VERSION?<span/>:
                  <ListItem button onClick={()=>showPage(24)} className={classes.nested}>
                    <ListItemIcon><Storage/></ListItemIcon>
                    <ListItemText primary={trans("OnPremisesServers")} sx={{cursor: 'pointer'}} />
                  </ListItem>
                }
              </List>
            </Collapse>
            <Divider/>
        </div>
        }

        {!hasBuildingDefinitionCategory()?<span/>:<div>
          <ListItem button onClick={handleClick10} style={open10?{background:'#e9eff2'}:{}}>
            <ListItemIcon>
              <Business />
            </ListItemIcon>
            <ListItemText primary={trans("building_definition")} sx={{cursor: 'pointer'}} />
            {open10 ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={open10} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
                <ListItem button onClick={()=>showPage(72)} className={classes.nested}>
                    <ListItemIcon><Business/></ListItemIcon>
                    <ListItemText primary={trans("building_definition")} sx={{cursor: 'pointer'}} />
                </ListItem>
                <ListItem button onClick={()=>showPage(74)} className={classes.nested}>
                      <ListItemIcon><Lock/></ListItemIcon>
                      <ListItemText primary={trans("device_floor_definition")} sx={{cursor: 'pointer'}}/>
                </ListItem>
            </List>
          </Collapse>
          <Divider/>
        </div>}

        {!hasUserCategory()?<span/>:<div>
          <ListItem button onClick={handleClick3} style={open3?{background:'#e9eff2'}:{}}>
            <ListItemIcon>
              <People />
            </ListItemIcon>
            <ListItemText primary={trans("user_mgmt")} sx={{cursor: 'pointer'}} />
            {open3 ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={open3} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {!hasRole("user_management")?<span/>:
                  <ListItem button onClick={()=>showPage(30)} className={classes.nested}>
                    <ListItemIcon><Person/></ListItemIcon>
                    <ListItemText primary={trans("overview")} sx={{cursor: 'pointer'}} />
                  </ListItem>
              }
            </List>
          </Collapse>
          <Divider/>
        </div>}

        {isJobAdmin() ? <div>
            <ListItem button onClick={handleClick4} style={open4?{background:'#e9eff2'}:{}}>
              <ListItemIcon>
                <Work />
              </ListItemIcon>
              <ListItemText primary="Jobs" sx={{cursor: 'pointer'}}/>
              {open4 ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open4} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>

                <ListItem button onClick={()=>showPage(40)} className={classes.nested}>
                  <ListItemIcon><FormatListBulletedIcon/></ListItemIcon>
                  <ListItemText primary="Overview" sx={{cursor: 'pointer'}}/>
                </ListItem>

                {canRelease()?
                  <ListItem button onClick={()=>showPage(41)} className={classes.nested}>
                    <ListItemIcon><ThumbUp/></ListItemIcon>
                    <ListItemText primary="Release" sx={{cursor: 'pointer'}} />
                  </ListItem>:<span/>}

                {canReview()?
                  <ListItem button onClick={()=>showPage(42)} className={classes.nested}>
                    <ListItemIcon><Visibility/></ListItemIcon>
                    <ListItemText primary="Review" sx={{cursor: 'pointer'}} />
                  </ListItem>:<span/>}

                <ListItem button onClick={()=>showPage(43)} className={classes.nested}>
                    <ListItemIcon><Search/></ListItemIcon>
                    <ListItemText primary="Database" sx={{cursor: 'pointer'}}/>
                </ListItem>

              </List>
            </Collapse>
            <Divider/>
            </div>
        :<span/>}

        {!isJobAdmin()?<div/>:<div>
            <ListItem button onClick={handleClick5} style={open5?{background:'#e9eff2'}:{}}>
              <ListItemIcon>
                <HomeWork/>
              </ListItemIcon>
              <ListItemText primary="Installations" sx={{cursor: 'pointer'}} />
              {open5 ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open5} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem button onClick={()=>showPage(50)} className={classes.nested}>
                  <ListItemIcon><FormatListBulletedIcon/></ListItemIcon>
                  <ListItemText primary="Overview" sx={{cursor: 'pointer'}} />
                </ListItem>
                <ListItem button onClick={()=>showPage(51)} className={classes.nested}>
                  <ListItemIcon><AddLocation/></ListItemIcon>
                  <ListItemText primary="Map" sx={{cursor: 'pointer'}} />
                </ListItem>
              </List>
            </Collapse>
            <Divider/>
          </div>}

          {!hasAdvertisingCategory() || ETVConstants.ON_PREMISE_VERSION?<div/>:<div>
            <ListItem button onClick={handleClick9} style={open9?{background:'#e9eff2'}:{}}>
              <ListItemIcon>
                <Redeem/>
              </ListItemIcon>
              <ListItemText primary="Advertising" sx={{cursor: 'pointer'}} />
              {open9 ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open9} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {!hasRole("advertising_approvals")?<span/>:
                  <ListItem button onClick={()=>showPage(91)} className={classes.nested}>
                    <ListItemIcon><AutoAwesome/></ListItemIcon>
                    <ListItemText primary={trans("approvals")} sx={{cursor: 'pointer'}}/>
                  </ListItem>
                }
                {!hasRole("advertising_approvals")?<span/>:
                  <ListItem button onClick={()=>showPage(92)} className={classes.nested}>
                    <ListItemIcon><Inventory/></ListItemIcon>
                    <ListItemText primary={trans("ads")} sx={{cursor: 'pointer'}}/>
                  </ListItem>
                }
                {!hasRole("advertising_definition")?<span/>:
                  <ListItem button onClick={()=>showPage(90)} className={classes.nested}>
                    <ListItemIcon><Settings/></ListItemIcon>
                    <ListItemText primary={trans("settings")} sx={{cursor: 'pointer'}} />
                  </ListItem>
                }
              </List>
            </Collapse>
            <Divider/>
          </div>}


          {!hasElevatorCategory()?<span/>:<div>
            <ListItem button onClick={handleClick6} style={open6?{background:'#e9eff2'}:{}}>
              <ListItemIcon>
                <Elevator/>
              </ListItemIcon>
              <ListItemText primary={trans("elevator")} sx={{cursor: 'pointer'}} />
              {open6 ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open6} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {!hasRole("elevator_config")?<span/>:
                    <ListItem button onClick={()=>showPage(60)} className={classes.nested}>
                      <ListItemIcon><Elevator/></ListItemIcon>
                      <ListItemText primary={trans("elevators")} sx={{cursor: 'pointer'}}/>
                    </ListItem>
                }
                {!hasRole("elevator_config") || ETVConstants.ON_PREMISE_VERSION?<span/>:
                    <ListItem button onClick={()=>showPage(65)} className={classes.nested}>
                      <ListItemIcon><HeadsetMic/></ListItemIcon>
                      <ListItemText primary={trans("intercom")} sx={{cursor: 'pointer'}}/>
                    </ListItem>
                }
                {/*
                {!hasRole("elevator_config")?<span/>:
                    <ListItem button onClick={()=>showPage(62)} className={classes.nested}>
                      <ListItemIcon><Engineering/></ListItemIcon>
                      <ListItemText primary={trans("service_technician")} sx={{cursor: 'pointer'}}/>
                    </ListItem>
                }
                */}
                {/*}
                {!hasRole("elevator_config")?<span/>:
                    <ListItem button onClick={()=>showPage(63)} className={classes.nested}>
                      <ListItemIcon><Work/></ListItemIcon>
                      <ListItemText primary={trans("job_definition")} sx={{cursor: 'pointer'}}/>
                    </ListItem>
                }
                */}
                {/*
                {!hasRole("elevator_config")?<span/>:
                    <ListItem button onClick={()=>showPage(64)} className={classes.nested}>
                      <ListItemIcon><Build/></ListItemIcon>
                      <ListItemText primary={trans("jobs")} sx={{cursor: 'pointer'}}/>
                    </ListItem>
                }
                */}
                {!hasRole("elevator_statistics") || ETVConstants.ON_PREMISE_VERSION?<span/>:
                  <ListItem button onClick={()=>showPage(61)} className={classes.nested}>
                    <ListItemIcon><Equalizer/></ListItemIcon>
                    <ListItemText primary={trans("statistics")} sx={{cursor: 'pointer'}}/>
                  </ListItem>
                }
              </List>
            </Collapse>
            <Divider/>
          </div>}

          {!hasSecurityCategory() || ETVConstants.ON_PREMISE_VERSION?<span/>:<div>
            <ListItem button onClick={handleClick7} style={open7?{background:'#e9eff2'}:{}}>
              <ListItemIcon>
                <Security/>
              </ListItemIcon>
              <ListItemText primary={trans("security_mgmt")} sx={{cursor: 'pointer'}} />
              {open7 ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open7} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                    {!hasRole("card_management")?<span/>:
                      <ListItem button onClick={()=>showPage(73)} className={classes.nested}>
                        <ListItemIcon><Lock/></ListItemIcon>
                        <ListItemText primary={trans("card_management")} sx={{cursor: 'pointer'}}/>
                      </ListItem>
                    }
                    {!hasRole("card_management")?<span/>:
                      <ListItem button onClick={()=>showPage(75)} className={classes.nested}>
                        <ListItemIcon><Face/></ListItemIcon>
                        <ListItemText primary={trans("face_recognition_terminals")} sx={{cursor: 'pointer'}}/>
                      </ListItem>
                    }
                    {!hasRole("cam")?<span/>:
                      <ListItem button onClick={()=>showPage(70)} className={classes.nested}>
                        <ListItemIcon><Videocam/></ListItemIcon>
                        <ListItemText primary={trans("ip_camera")} sx={{cursor: 'pointer'}} />
                      </ListItem>
                    }
                    {!hasRole("cam")?<span/>:
                      <ListItem button onClick={()=>showPage(71)} className={classes.nested}>
                        <ListItemIcon><CameraAlt/></ListItemIcon>
                        <ListItemText primary={trans("usb_camera")} sx={{cursor: 'pointer'}}/>
                      </ListItem>
                    }
              </List>
            </Collapse>
            <Divider/>
          </div>}

          <div>
            <ListItem button onClick={handleClick8} style={open8?{background:'#e9eff2'}:{}}>
              <ListItemIcon>
                <Info/>
              </ListItemIcon>
              <ListItemText primary={trans("about")} sx={{cursor: 'pointer'}}/>
              {open8 ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open8} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                  <ListItem button onClick={()=>showPage(80)} className={classes.nested}>
                    <ListItemIcon><AccountCircle/></ListItemIcon>
                    <ListItemText primary={trans("my_details")} sx={{cursor: 'pointer'}} />
                  </ListItem>
                  { ETVConstants.ON_PREMISE_VERSION?<span/>:
                    <ListItem button onClick={()=>showPage(82)} className={classes.nested}>
                      <ListItemIcon><Help/></ListItemIcon>
                      <ListItemText primary={trans("support")} sx={{cursor: 'pointer'}}/>
                    </ListItem>
                  }
                  {!hasRole("audit_log")?<span/>:
                    <ListItem button onClick={()=>showPage(83)} className={classes.nested}>
                      <ListItemIcon><VerifiedUser/></ListItemIcon>
                      <ListItemText primary={trans("audit_logs")} sx={{cursor: 'pointer'}}/>
                    </ListItem>
                  }
              </List>
            </Collapse>
          </div>
      </List>
      <main className={classes.content}>
          {
            curPage===10 ?<Playlist lang={props.lang} user_id={props.user_id} children={props.children} roles={props.roles} />:
            curPage===11 ?<ContentLibrary lang={props.lang} user_id={props.user_id} children={props.children} marketplace={false} roles={props.roles} />:
            curPage===12 ?<EditText lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===13 ?<Newsticker lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===14 ?<WeatherInfo lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===15 ?<SurveyMgmt lang={props.lang} user_id={props.user_id} />:
            curPage===16 ?<VoucherMgmt lang={props.lang} user_id={props.user_id} />:
            curPage===17 ?<Countdown lang={props.lang} user_id={props.user_id} />:
            curPage===18 ?<FloorDirectory lang={props.lang} user_id={props.user_id} />:

            curPage===19 ?<RSSCreator lang={props.lang} user_id={props.user_id} />:
            curPage===191 ?<Calendar lang={props.lang} user_id={props.user_id} />:
            curPage===192 ?<Whatsapp lang={props.lang} user_id={props.user_id} />:
            curPage===193 ?<EmailAdapter lang={props.lang} user_id={props.user_id} />:
            curPage===194 ?<ApprovalLibrary lang={props.lang} user_id={props.user_id} />:
            curPage===195 ?<ContentPlanner lang={props.lang} user_id={props.user_id} />:

            curPage===20 ?<DeviceMgmt lang={props.lang} user_id={props.user_id} roles={props.roles} status={props.status} />:
            curPage===21 ?<RemoteDeviceMgmt lang={props.lang} user_id={props.user_id} status={props.status} />:
            curPage===22 ?<LayoutDesigner lang={props.lang} user_id={props.user_id} />:
            curPage===23 ?<GroupMgmt lang={props.lang} user_id={props.user_id} roles={props.roles} status={props.status} />:
            curPage===24 ?<OnPremisesServers lang={props.lang} user_id={props.user_id} />:

            curPage===30 ?<UserMgmt lang={props.lang} user_id={props.user_id} roles={props.roles} status={props.status} />:

            curPage===60 ?<ElevatorMgmt lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===61 ?<ElevatorStatistics lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===62 ?<ServiceTechnician lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===63 ?<JobDefinition lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===64 ?<Jobs lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===65 ?<IntercomMgmt lang={props.lang} user_id={props.user_id} roles={props.roles} />:

            curPage===70 ?<SecurityMgmtIPCamera lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===71 ?<SecurityMgmt lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===72 ?<AccessMgmt lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===73 ?<CardMgmt lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===74 ?<DeviceFloorMgmt lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===75 ?<FaceTerminalMgmt lang={props.lang} user_id={props.user_id} roles={props.roles} />:

            curPage===80 ?<EditUserAccount lang={props.lang} user_id={props.user_id} username={props.username} status={props.status} roles={props.roles} />:
            curPage===81 ?<AccountUpgrade lang={props.lang} user_id={props.user_id} />:
            curPage===82 ?<Support lang={props.lang} user_id={props.user_id} />:
            curPage===83 ?<AuditLog lang={props.lang} user_id={props.user_id} />:

            curPage===90 ?<AdvertisingConfig lang={props.lang} user_id={props.user_id} />:
            curPage===91 ?<AdvertisingApprovals lang={props.lang} user_id={props.user_id} />:
            curPage===92 ?<ExistingApprovals lang={props.lang} user_id={props.user_id} />:
            <span/>
          }
      </main>
    </div>
  );
}
